import { ChangeDetectorRef, Component, Injector, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { NotificationCountUpdatedService } from '@shared/helpers/notification-count-updated.service';
import { BaseMessageNotificationDataDto, NotificationServiceProxy } from '@shared/service-proxies/service-proxies';
import {NotificationService} from './notification.service';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent extends AppComponentBase implements OnInit {
  notificationsList: BaseMessageNotificationDataDto[];
  dropdownOpenId: string | null = null;

  @Output() closePopover: EventEmitter<void> = new EventEmitter();

  tooltipsVisible: { [key: string]: boolean } = {};

showTooltip(id: string): void {
  this.tooltipsVisible[id] = true;
}

hideTooltip(id: string): void {
  this.tooltipsVisible[id] = false;
}


  constructor(
    injector: Injector,
    private _notificationService: NotificationServiceProxy,
    private _notificationCountUpdatedService: NotificationCountUpdatedService,
    private cdr: ChangeDetectorRef,
    private _notificationParamService:NotificationService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this._notificationService
    .getNotificationsInfo()
    .subscribe((result: BaseMessageNotificationDataDto[]) => {
      this.notificationsList = result;
      this.cdr.detectChanges();
    });
  }

  setNotificationAsRead(notificationId: string): void {
    this._notificationService
    .setNotificationAsRead(notificationId)
    .subscribe({
      next: () => {
        this.notificationsList = [];
        this._notificationCountUpdatedService.setNewNotificationRefresh(true);
        this._notificationCountUpdatedService.notifyNotificationRead();
        this.ngOnInit();
      }
    });
  }

  setNotificationAsArchived(notificationId: string): void {
    this._notificationService
    .setNotificationAsArchived(notificationId)
    .subscribe({
      next: () => {
        this.notificationsList = [];
        this._notificationCountUpdatedService.setNewNotificationRefresh(true);
        this.ngOnInit();
      }
    });
  }

  setAllNotificationsAsRead(): void {
    this._notificationService
    .setAllNotificationsAsArchivated()
    .subscribe({
      next: () => {
        this.notificationsList = [];
        this._notificationCountUpdatedService.setNewNotificationRefresh(true);
        this._notificationCountUpdatedService.notifyNotificationRead();
        this.cdr.detectChanges();
      }
    });
  }

  timeSince(notificationDate: Moment): string {
    const now = moment();
    const duration = moment.duration(now.diff(notificationDate));

    const days = Math.floor(duration.asDays());
    const hours = Math.floor(duration.asHours() % 24);
    const minutes = Math.floor(duration.asMinutes() % 60);
    const seconds = Math.floor(duration.asSeconds() % 60);

    if (days > 0) {
        const dayText = this.l('day');
        const daysText = this.l('days');
        return days === 1 ? `1 ` + dayText : `${days} ` + daysText;
    } else if (hours > 0) {
        const hourText = this.l('hour');
        const hoursText = this.l('hours');
        return hours === 1 ? `1 ` + hourText : `${hours} ` + hoursText;
    } else if (minutes > 0) {
        const minuteText = this.l('minute');
        const minutesText = this.l('minutes');
        return minutes === 1 ? `1 ` + minuteText : `${minutes} ` + minutesText;
    } else {
        const secondText = this.l('second');
        const secondsText = this.l('seconds');
        return seconds === 1 ? `1 ` + secondText : `${seconds} ` + secondsText;
    }
  }

  toggleDropdown(notificationId: string) {
    if (this.dropdownOpenId === notificationId) {
      this.dropdownOpenId = null;
    } else {
      this.dropdownOpenId = notificationId;
    }
  }

  isDropdownOpen(notificationId: string): boolean {
    return this.dropdownOpenId === notificationId;
  }

  navigateToComponentByNotification(notificationId: string): Promise<boolean> {
    this._notificationParamService.setNotificationId(notificationId);
    this.closePopover.emit();
    return this.router.navigateByUrl(`/app/user-diary`);
  }

  navigateToComponent(): Promise<boolean> {
    this.closePopover.emit();
    return this.router.navigateByUrl('/app/user-diary');
  }

}
